import { createAsyncThunk } from '@reduxjs/toolkit';
import * as skillLaunchService from './skill-launch-api';
import { ISaveSkillViewPayload } from '../../../libs/utils/interfaces/skill-launch-interface';
import type { IRootState } from '../../app/store';

export const saveSkillView = createAsyncThunk(
    'SkillLaunch/saveSkillView',
    async (payload: ISaveSkillViewPayload, { rejectWithValue, getState }) => {
        try {
            const { isWhitelisted } = (getState() as IRootState)
                .referentialAccess;
            const response = await skillLaunchService.saveSkillView(
                payload,
                isWhitelisted
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getCourseDetails = createAsyncThunk(
    'SkillLaunch/getCourseDetailsThunk',
    async (courseId: number, { rejectWithValue }) => {
        try {
            const response = await skillLaunchService.getCourseDetails(
                courseId
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getCourseIdsByCourseIdentifiers = createAsyncThunk(
    'SkillLaunch/getCourseIdsByCourseIdentifiers',
    async (courseIdentifiers: any, { rejectWithValue }) => {
        try {
            const response =
                await skillLaunchService.getCourseIdsByCourseIdentifiers(
                    courseIdentifiers
                );
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
